export default "__VITE_ASSET__LC1d0tj8__"